<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: ElementFormModal.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,      -->
<!-- propagated, or distributed without prior approval by ESA.                  -->
<template>
  <div class="modal element-form-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button
            type="button"
            class="modal__elements-close close"
            data-dismiss="modal"
            aria-label="Close"
            @click="$emit('closeFormModal')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div v-if="formItemsWithInput" class="modal-body">
          <div v-for="(item, index) in formItemsWithInput" :key="item.key" class="form-group">
            <label v-show="!(item.label == 'Picture' && mode == 'Add')" :for="item">{{
              item.label
            }}</label>
            <multiselect
              v-if="item.label == 'Resource Type'"
              v-model="item.input"
              :options="resourceTypeOptions"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
            ></multiselect>
            <multiselect
              v-else-if="item.label == 'Format'"
              v-model="item.input"
              :options="fileFormatOptions"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
            ></multiselect>
            <!-- CONTRIBUTOR ROLE -->
            <div v-else-if="item.label == 'Contributor Role'">
              <div class="border border-secondary p-3 mb-2" v-for="(role, idx) in item.input">
                <button
                  v-if="idx != 0"
                  class="btn btn-sm btn-secondary float-right d-block"
                  @click="removeContributorRole(idx)"
                >
                  X
                </button>
                <br />
                <label class="mb-0" for="role_name">Role Name</label>
                <input
                  id="role_name"
                  class="modal__elements form-control"
                  type="text"
                  v-model="role.role_name"
                  @change="onChange"
                  @click="onClick"
                />
                <label class="mb-0" for="contributor_approach">Contributor Approach</label>
                <input
                  id="contributor_approach"
                  class="modal__elements form-control"
                  type="text"
                  v-model="role.contributor_approach"
                  @change="onChange"
                  @click="onClick"
                />
                <label class="mb-0" for="staging_location">Staging Location</label>
                <input
                  id="staging_location"
                  class="modal__elements form-control"
                  type="text"
                  v-model="role.staging_location"
                  @change="onChange"
                  @click="onClick"
                />
              </div>
              <button class="btn btn-sm btn-secondary" @click="addContributorRole">Add new</button>
            </div>
            <!-- SUBPATHS -->
            <div v-else-if="item.label == 'Subpaths'">
              <div class="border border-secondary p-3 mb-2" v-for="(subpath, idxS) in item.input">
                <button
                  v-if="idxS != 0"
                  class="btn btn-sm btn-secondary float-right d-block"
                  @click="removeSubpath(idxS)"
                >
                  X
                </button>
                <br />
                <label class="mb-0" for="subpath">Subpath</label>
                <input
                  id="subpath"
                  class="modal__elements form-control"
                  type="text"
                  v-model="subpath.subpath"
                  @change="onChange"
                  @click="onClick"
                />
                <label class="mb-0" for="filter_params">Filter Params</label>
                <div
                  class="border border-secondary p-3 mb-2"
                  v-for="(filterParams, idxF) in subpath.filter_params"
                >
                  <button
                    v-if="idxF != 0"
                    class="btn btn-sm btn-secondary float-right d-block"
                    @click="removeFilterParams(idxS, idxF)"
                  >
                    X
                  </button>
                  <label class="mb-0" for="key">Key</label>
                  <input
                    id="key"
                    class="modal__elements form-control"
                    type="text"
                    v-model="filterParams.key"
                    @change="onChange"
                    @click="onClick"
                  />
                  <label class="mb-0" for="value">Value</label>
                  <input
                    id="value"
                    class="modal__elements form-control"
                    type="text"
                    v-model="filterParams.value"
                    @change="onChange"
                    @click="onClick"
                  />
                </div>
                <button class="btn btn-sm btn-secondary" @click="addFilterParams(idxS)">
                  Add new
                </button>
              </div>
              <button class="btn btn-sm btn-secondary" @click="addSubpath">Add new</button>
            </div>
            <div v-else-if="item.label == 'Picture'" v-show="mode == 'Edit'">
              <div class="float-left" v-if="previewPicture">
                <img class="preview" :src="previewPicture" alt="" />
              </div>
              <button
                v-if="previewPicture"
                class="btn btn-sm btn-secondary d-block float-left"
                @click="removePicture()"
              >
                X
              </button>
              <button
                class="btn btn-sm btn-secondary clear d-block"
                onclick="document.getElementById('getFile').click()"
              >
                Select picture file
              </button>
              <input
                class="select-picture-input"
                type="file"
                id="getFile"
                style="display:none"
                ref="file"
                accept="image/*"
                @change="selectPicture"
              />
              <!-- <button v-if="previewPicture" class="btn btn-sm btn-secondary" @click="uploadPicture()">
                Upload picture
              </button> -->
            </div>
            <input
              v-else
              :ref="'elementIndexRef' + index"
              type="text"
              :id="item.key"
              class="modal__elements form-control"
              v-model="item.input"
              @change="onChange"
              @click="onClick"
            />
          </div>
          <!-- <button
            class="modal__elements-saveedit btn btn-primary"
            @click="testMethod"
          >
            {{ title.replace("Edit", "Save") }}
          </button>-->
          <button class="modal__elements-cancel btn btn-primary" data-dismiss="modal">
            Cancel
          </button>
          <button
            class="modal__elements-saveedit btn btn-primary float-right"
            data-dismiss="modal"
            @click="saveElement"
          >
            {{ title.replace('Edit', 'Save') }}
          </button>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import helpers from '@/lib/helpers'
import * as api from '@/lib/api'
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Multiselect,
  },
  props: {
    mode: String,
    title: String,
    dataType: String,
    catalogueFields: Object,
    initData: Object,
    arrayFields: Array,
  },
  data() {
    return {
      formItemsWithInput: null,
      resourceTypes: null,
      resourceTypeOptions: null,
      fileFormats: null,
      fileFormatOptions: null,
      // Picture related vars
      currentPicture: undefined,
      previewPicture: undefined,
      progress: 0,
      message: '',
      pictureInfos: [],
    }
  },
  computed: {
    apiFields() {
      const keys = this.formItemsWithInput.map((item) => this.catalogueFields[item['label']])
      const values = this.formItemsWithInput.map((item) => {
        if (this.arrayFields.includes(item.label)) {
          if (item.input) {
            if (item.label == 'Resource Type') {
              if (item.input[0] != 'Not Available') {
                return item.input.map((el) => this.resourceTypes.find((it) => el == it.name).id)
              } else {
                return []
              }
            } else if (item.label == 'Format') {
              if (item.input[0] != 'Not Available') {
                return item.input.map((el) => this.fileFormats.find((it) => el == it.name).id)
              } else {
                return []
              }
            } else if (item.label == 'Contributor Role') {
              // need to return only certain fields
              return item.input.map(({ dataset_id, role_id, ...rest }) => rest)
            } else if (item.label == 'Subpaths') {
              // need to return only certain fields
              // let subpaths = item.input.map(({ dataset_id, subpath_id, ...rest }) => rest)
              return item.input.map((subpath) => {
                return {
                  subpath: subpath.subpath,
                  filter_params: subpath.filter_params.map(({ filter_param_id, ...rest }) => rest),
                }
              })
            } else {
              return item.input.split(',') //`["${item.input}"]`
            }
          }
          // }
        } else {
          return item.input
        }
      })
      let apiObject = {}
      keys.forEach((key, i) => (apiObject[key] = values[i]))
      return apiObject
    },
  },
  methods: {
    onChange() {
      console.log('change')
    },
    onClick() {
      console.log('click')
    },
    testMethod() {
      console.log(this.apiFields)
    },
    async updateFormItems() {
      const response = await api.getResourceTypes()
      this.resourceTypes = response.results.map((el) => ({
        id: el.resource_type_id,
        name: el.name,
      }))
      this.resourceTypeOptions = this.resourceTypes.map((el) => el.name)
      this.fileFormats = response.file_formats.map((el) => ({
        id: el.file_format_id,
        name: el.name,
      }))
      this.fileFormatOptions = response.file_formats.map((el) => el.name)
      console.log('datito', this.catalogueFields)
      this.formItemsWithInput = Object.keys(this.catalogueFields)
        .filter((item) => item != 'ID' && item != 'Datalabs') // Filter ID element & Datalabs element which is not editable
        .map((item) =>
          Object.assign({
            key: this.catalogueFields[item],
            label: item,
            input:
              this.catalogueFields[item] == 'contributor_role'
                ? [{ ...this.EMPTYCONTRIBUTORROLE }]
                : this.catalogueFields[item] == 'subpaths'
                ? [JSON.parse(JSON.stringify(this.EMPTYSUBPATH))]
                : '',
          })
        ) //create frontend object

      console.log('contrib ...', this.formItemsWithInput)

      if (this.mode === 'Edit') {
        this.formItemsWithInput.forEach((item) => {
          let inputValue = ''
          if (item.key == 'resource_type') {
            // inputValue = this.initData['resource_type_id'].join()
            inputValue = this.initData['resource_type']
          } else if (item.key == 'format') {
            inputValue = this.initData['format']
          } else if (item.key == 'contributor_role') {
            const initData = this.initData[item.key]
            inputValue = this.initData[item.key]
            if (initData[0] == 'Not Available') {
              inputValue = [{ ...this.EMPTYCONTRIBUTORROLE }]
            }
          } else if (item.key == 'subpaths') {
            const initData = this.initData[item.key]
            inputValue = this.initData[item.key]
            if (initData[0] == 'Not Available') {
              inputValue = [JSON.parse(JSON.stringify(this.EMPTYSUBPATH))]
            }
          } else if (item.key == 'picture') {
            console.log('picture!!', item)
            inputValue = this.initData[item.key]
            if (inputValue && inputValue != 'None') this.previewPicture = inputValue
          } else {
            inputValue = Array.isArray(this.initData[item.key])
              ? this.initData[item.key].join()
              : this.initData[item.key]
          }
          item.input = inputValue
        })
      }
      // for some weird reason this is an array in this case ...
      this.$nextTick(() => this.$refs.elementIndexRef0[0].focus())
    },
    addContributorRole() {
      // console.log('contrib ', this.formItemsWithInput.find((item) => item.key == 'contributor_role'))
      let contributorRoles = this.formItemsWithInput.find((item) => item.key == 'contributor_role')
      let contributorRolesArray =
        Array.isArray(contributorRoles.input) && contributorRoles.input.length > 0
          ? contributorRoles.input
          : []
      contributorRolesArray.push(JSON.parse(JSON.stringify(this.EMPTYCONTRIBUTORROLE)))
      // console.log('contrib ', contributorRolesArray)
    },
    removeContributorRole(idx) {
      let contributorRoles = this.formItemsWithInput.find((item) => item.key == 'contributor_role')
      let contributorRolesArray =
        Array.isArray(contributorRoles.input) && contributorRoles.input.length > 0
          ? contributorRoles.input
          : []
      contributorRolesArray.splice(idx, 1)
    },
    addSubpath() {
      let subpaths = this.formItemsWithInput.find((item) => item.key == 'subpaths')
      let subpathsArray =
        Array.isArray(subpaths.input) && subpaths.input.length > 0 ? subpaths.input : []
      let newSubpath = JSON.parse(JSON.stringify(this.EMPTYSUBPATH))
      subpathsArray.push(newSubpath)
    },
    removeSubpath(idx) {
      let subpaths = this.formItemsWithInput.find((item) => item.key == 'subpaths')
      let subpathsArray =
        Array.isArray(subpaths.input) && subpaths.input.length > 0 ? subpaths.input : []
      subpathsArray.splice(idx, 1)
    },
    addFilterParams(idxSubpath) {
      let subpaths = this.formItemsWithInput.find((item) => item.key == 'subpaths')
      let subpathsArray =
        Array.isArray(subpaths.input) && subpaths.input.length > 0 ? subpaths.input : []
      let filterParamsArray = subpathsArray[idxSubpath].filter_params
      filterParamsArray.push(JSON.parse(JSON.stringify(this.EMPTYFILTERPARAMS)))
    },
    removeFilterParams(idxSubpath, idx) {
      let subpaths = this.formItemsWithInput.find((item) => item.key == 'subpaths')
      let subpathsArray =
        Array.isArray(subpaths.input) && subpaths.input.length > 0 ? subpaths.input : []
      let filterParamsArray = subpathsArray[idxSubpath].filter_params
      filterParamsArray.splice(idx, 1)
    },
    selectPicture(e) {
      this.currentPicture = e.target.files[0]
      this.previewPicture = URL.createObjectURL(this.currentPicture)
      console.log('picture', this.currentPicture)
      this.progress = 0
      this.message = ''
    },
    async uploadPicture() {
      console.log('picture trying upload', this.currentPicture)
      console.log('picture id', this.initData.id)
      // Two types of data can have picture, resource types and file formats
      let dataTypePath = ''
      if (this.dataType === 'Resource Type') {
        dataTypePath = 'resource-types'
      } else if (this.dataType === 'File Format') {
        dataTypePath = 'file-format'
      }
      const response = api
        .uploadPicture(
          this.currentPicture,
          this.initData.id,
          (event) => {
            this.progress = Math.round((100 * event.loaded) / event.total)
          },
          dataTypePath
        )
        .then((response) => {
          console.log('picture Response from server', response)
          this.previewPicture = undefined
        })
        .catch((err) => {
          this.progress = 0
          console.log('picture Error from server', JSON.stringify(err))
        })
    },
    removePicture() {
      this.currentPicture = undefined
      this.previewPicture = undefined
      this.uploadPicture()
    },
    saveElement() {
      if (this.currentPicture) this.uploadPicture()
      this.$emit('createOrEditNewElement', {
        mode: this.mode,
        id: this.initData.id,
        apiFields: this.apiFields,
      })
    },
  },
  created() {
    // Just a way to create a constant available in the component
    // and not make it unnecesarily reactive by putting it in data.
    this.EMPTYCONTRIBUTORROLE = {
      dataset_id: '',
      contributor_approach: '',
      role_id: '',
      role_name: '',
      staging_location: '',
    }
    this.EMPTYSUBPATH = {
      filter_params: [
        {
          key: '',
          filter_param_id: '',
          value: '',
        },
      ],
      subpath_id: '',
      subpath: '',
      dataset_id: '',
    }
    this.EMPTYFILTERPARAMS = {
      key: '',
      filter_param_id: '',
      value: '',
    }
  },
  mounted() {
    this.updateFormItems()
  },
  watch: {
    mode: function() {
      this.updateFormItems()
    },
  },
}
</script>
<style lang="scss">
@import '~@/styles/globals';
@import '~vue-multiselect/dist/vue-multiselect.min';

.select-picture-input {
  min-width: 300px;
}

img {
  &.preview,
  &.picture {
    width: 120px;
    height: 120px;
    object-fit: contain;
  }
}

.clear {
  clear: both;
}

.multiselect {
  &__select {
  }

  &__tags {
    border: 1px solid #ced4da;
    border-radius: 2px;
  }

  &__tag {
    background-color: $main;

    &-icon {
      &::after {
        color: $primary;
      }

      &:hover {
        background: $main;
      }
    }
  }

  &__option {
    // #{&} esto solo es una forma de poder repetir el &
    // significa &--selected&--highlight, las 2 clases, pero eso no lo entiende.
    &--selected#{&}--highlight {
      color: $primary;
      background: #f3f3f3;

      &::after {
        color: $primary;
        background: #f3f3f3;
      }
    }

    &--highlight {
      background-color: $main;

      &::after {
        background: $main;
      }
    }
  }

  &__content-wrapper {
    border: 1px solid #828588;
  }

  &__content {
  }

  &__element {
  }
}
</style>
